import { FC, ReactNode } from 'react'

import Box from '@mui/material/Box'
import { GRAY_900 } from 'constants/styling/theme'
import Stack from '@mui/material/Stack'

interface Props {
  /** Title of the section */
  title?: string
  children: ReactNode
}

/**
 * Section header + children wrapper for assignment detail drawer content.
 * @example
 * <DetailSection title="Configuration">
 *   <DetailField label="Style" value="Modern" />
 * </DetailSection>
 */
export const DetailSection: FC<Props> = ({ title, children }) => (
  <Stack paddingBottom="2.4rem">

    {!!title &&
      <Box
        fontSize="1.6rem"
        fontWeight={550}
        color={GRAY_900}
        marginBottom="1.6rem"
      >
        {title}
      </Box>
    }

    {children}

  </Stack>
)
